<template>
  <div>
    <div class="container">
      <h2 class="title is-2">
        {{film.title}}
        <span
          class="tag is-large"
          :class="{'is-info': film.mosaic}"
        >{{film.mosaic ? '有码' : '无码'}}</span>
      </h2>
      <div class="box" style="margin-top: 1rem;">
        <div class="columns is-desktop">
          <div class="column is-two-thirds">
            <figure class="image is-3by2">
              <img :src="film['cover']" />
            </figure>
          </div>
          <div class="column">
            <table class="table is-fullwidth is-striped is-bordered">
              <tbody>
                <tr>
                  <th>编号</th>
                  <td>{{film.code}}</td>
                </tr>
                <tr v-if="film.duration">
                  <th>长度</th>
                  <td>{{film.duration}} 分</td>
                </tr>
                <tr v-if="film.release_date">
                  <th>发行时间</th>
                  <td>
                    <router-link
                      :to="{path:'/filmBoard', query: {release_date: film.release_date}}"
                    >{{film.release_date}}</router-link>
                  </td>
                </tr>
                <tr v-if="film.director">
                  <th>导演</th>
                  <td>
                    <router-link
                      :to="{path:'/filmBoard', query: {director: film.director}}"
                    >{{film.director}}</router-link>
                  </td>
                </tr>
                <tr v-if="film.series">
                  <th>系列</th>
                  <td>
                    <router-link
                      :to="{path:'/filmBoard', query: {series: film.series}}"
                    >{{film.series}}</router-link>
                  </td>
                </tr>
                <tr v-if="film.studio">
                  <th>制作商</th>
                  <td>
                    <router-link
                      :to="{path:'/filmBoard', query: {studio: film.studio}}"
                    >{{film.studio}}</router-link>
                  </td>
                </tr>
                <tr v-if="film.publisher">
                  <th>发行商</th>
                  <td>
                    <router-link
                      :to="{path:'/filmBoard', query: {publisher: film.publisher}}"
                    >{{film.publisher}}</router-link>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="content is-small" v-if="film.genre && film.genre.length > 0">
              <h4>类型</h4>
              <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                  <li v-for="i in film.genre" :key="i">
                    <router-link :to="{path:'/filmBoard', query: {genre: i}}">{{i}}</router-link>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="content is-small" v-if="film.actor && film.actor.length > 0">
              <h4>演员</h4>
              <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                  <li v-for="i in film.actor" :key="i">
                    <router-link :to="{path:'/filmBoard', query: {actor: i}}">{{i}}</router-link>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="content is-small">
              <h4>站外链接</h4>
              <nav class="breadcrumb" aria-label="breadcrumbs">
                <div class="field is-grouped">
                  <p class="control">
                    <a
                      class="button is-info is-outlined"
                      :href="film.original_link"
                      target="_blank"
                    >
                      <span class="icon is-small">
                        <i class="fas">
                          <figure class="image is-16x16">
                            <img src="https://www.javbus.com/favicon.ico" />
                          </figure>
                        </i>
                      </span>
                      <span>JavBus</span>
                    </a>
                  </p>
                  <p class="control">
                    <a
                      class="button is-info is-outlined"
                      :href="'http://www.javlibrary.com/cn/vl_searchbyid.php?keyword=' + film.code"
                      target="_blank"
                    >
                      <span class="icon is-small">
                        <i class="fas">
                          <figure class="image is-16x16">
                            <img src="http://www.javlibrary.com/favicon.ico" />
                          </figure>
                        </i>
                      </span>
                      <span>JavLibrary</span>
                    </a>
                  </p>
                </div>
              </nav>
            </div>
          </div>
        </div>
        <div class="box" v-if="film.preview" v-viewer>
          <template v-for="t in Math.ceil(film.preview.length / 6)">
            <div class="columns is-desktop" :key="t">
              <template v-for="p in 6">
                <div class="column is-2" :key="p" v-if="(t-1)*6+p-1 < film.preview.length">
                  <figure class="image">
                    <img :src="film.preview[(t-1)*6+p-1]" />
                  </figure>
                </div>
              </template>
            </div>
          </template>
        </div>
        <template v-if="film.links && film.links.length > 0">
          <hr />
          <table class="table is-fullwidth is-bordered is-striped">
            <thead>
              <tr>
                <th></th>
                <th>磁力</th>
                <th>大小</th>
                <th>日期</th>
              </tr>
            </thead>
            <tbody v-for="(l) in film.links" v-bind:key="l.magnet">
              <tr>
                <th>
                  <button class="button is-small" v-clipboard:copy="l.magnet">
                    <span class="icon is-small">
                      <i class="fas fa-copy"></i>
                    </span>
                  </button>
                </th>
                <td>
                  <a :href="l.magnet" :title="l.name">{{l.name}}</a>
                  <template v-for="t in l.tags">
                    <span
                      class="tag"
                      :class="{'is-info': t=='高清', 'is-warning': t=='字幕'}"
                      v-bind:key="t"
                    >{{t}}</span>
                  </template>
                </td>
                <td>{{l.size}}</td>
                <td>{{l.date}}</td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import Viewer from "v-viewer";

import "viewerjs/dist/viewer.css";

Vue.use(VueClipboard);
Vue.use(Viewer);

export default {
  name: "Film",
  props: {},
  data() {
    return {
      film: {}
    };
  },
  methods: {
    backToTop: function() {
      let currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.backToTop);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    }
  },
  activated: function() {
    const realSize = function(text) {
      let ans = text.match(/([\d|.]+)(\w+)/);
      if (ans[2] == "GB") {
        return ans[1] * 1024;
      }
      return parseFloat(ans[1]);
    };
    if (Object.keys(this.$route.params).length > 1) {
      this.film = this.$route.params;
      document.title = `${this.film.code} ${this.film.title}`;
      this.film.links.sort((a, b) => realSize(b.size) - realSize(a.size));
    } else {
      axios.get("/api/v1/jav/film/" + this.$route.params.code).then(res => {
        this.film = res.data;
        document.title = `${this.film.code} ${this.film.title}`;
        this.film.links.sort((a, b) => realSize(b.size) - realSize(a.size));
      });
    }
  },
  watch: {
    film: function() {
      //this.backToTop();
    }
  }
};
</script>

<style scoped>
span.tag {
  margin-left: 1rem;
}
.content li + li {
  margin-top: 0;
}
</style>
